module.exports = __webpack_public_path__ + "static/media/deep_oak.51f42709.png";